import PcMonitoring from 'quality/components/pcMonitoring/PcMonitoring'
import React, { useMemo } from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'
import { shallowEqual, useSelector } from 'react-redux'
import { useParams } from 'react-router'

const InstallationPcMonitoringApp = () => {
    const { id } = useParams()

    const {
        installation,
        associatedSites,
    } = useSelector(store => ({
        installation: store.InstallationReducer.installation,
        associatedSites: store.StationReducer.associatedSites,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.installation,
        href: 'installation',
    }, {
        title: getStationTitle(installation),
        href: `station/installation/${id}`,
    }, {
        title: i18n.followUpPC,
        href: `station/installation/${id}/pcMonitoring`,
    }], [])

    const ids = useMemo(() => associatedSites.filter(site => site.stationLinkedType === 3).map(site => site.stationLinkedId), [associatedSites])

    return (
        <PcMonitoring
            ids={ids}
        />
    )
}

export default InstallationPcMonitoringApp